import { objToLabelColorObj } from 'utils/util'

// 状态 key-value值
export const STATUS_OBJ = {
  1: {
    label: '生效中',
    color: 'green',
  },
  2: {
    label: '已取消',
    color: 'gray',
  },
  3: {
    label: '已失效',
    color: 'red',
  },
}

// 审批操作
export const APPROVAL_ACTION_OBJ = {
  PASS: 1,
  REJECT: 2,
}

// 批量状态
export const BATCH_STATUS_OBJ = {
  0: {
    label: '待验证',
    color: 'pink',
  },
  1: {
    label: '验证通过',
    color: 'cyan',
  },
  2: {
    label: '验证不通过',
    color: 'orange',
  },
  3: {
    label: '审批中',
    color: 'blue',
  },
  4: {
    label: '审批通过',
    color: 'green',
  },
  5: {
    label: '审批拒绝',
    color: 'red',
  },
}
// 申请时可选的信用类型list
export const CREDIT_TYPE_LIST = [
  {
    label: '关联共享',
    value: '1',
  },
  {
    label: '关联分配',
    value: '2',
  },
]
export const STATUS_COLOR_OBJ = objToLabelColorObj(STATUS_OBJ)

// 上传方式
export const ALLOCATE_TYPE_OBJ = {
  1: '普通上传',
  2: '批量上传',
}
